(ns dashboard.views.browser-extension.new-questionnaire.config)

(def view-id :route.view/extension-new-questionnaire)
